import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { manifest as communitiesManifest } from 'modules/posts/lib/manifest'
import { manifest as engagementSurveysManifest } from 'modules/engagement_surveys/lib/manifest'
import { manifest as financeManifest } from 'modules/finance/lib/manifest'
import { manifest as formsManifest } from 'modules/forms/lib/manifest'
import { manifest as itManagementManifest } from 'modules/it_management/lib/manifest'
import { manifest as ticketingManifest } from 'modules/ticketing/lib/manifest'
import { manifest as operationsManifest } from 'modules/operations/lib/manifest'
import { manifest as procurementManifest } from 'modules/procurement/lib/manifest'
import { manifest as projectManagementManifest } from 'modules/project_management/lib/manifest'
import { manifest as spaceControlManifest } from 'modules/space_control/lib/manifest'
import { manifest as talentManifest } from 'modules/talent/lib/manifest'
import { manifest as trainingsManifest } from 'modules/trainings/lib/manifest'

import { manifest as coreManifest } from './index'

export const manifests = {
  core: coreManifest,
  communities: communitiesManifest,
  operations: operationsManifest,
  finance: financeManifest,
  talent: talentManifest,
  it_management: itManagementManifest,
  ticketing: ticketingManifest,
  engagement_surveys: engagementSurveysManifest,
  trainings: trainingsManifest,
  forms: formsManifest,
  project_management: projectManagementManifest,
  space_control: spaceControlManifest,
  procurement: procurementManifest,
}

export const sidebarInfo = (navigation: Navigation<NavigationPaths>) => {
  return Object.values(manifests).flatMap(
    (moduleManifest) => moduleManifest.sidebar(navigation).items
  )
}

export type ManifestsType = typeof manifests
